import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { ActivatedRoute, Router } from '@angular/router'
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { Console, debug } from 'console';
import { differenceInCalendarDays, addDays, parseISO, format, differenceInDays } from 'date-fns';
import { promise } from 'protractor';
import { id_ID } from 'ng-zorro-antd/i18n';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { DatePipe } from '@angular/common'

interface WHQMaintainDto {
  Pono: string;
  Currency: string;
  InvoiceDate: string;
  InvoiceAmount: string;
  InvoiceNo: string;
  Taxes: string;
  remake: string;
}
@Component({
  selector: 'app-edit-wmsm-ManualInvoice',
  templateUrl: './edit-wmsm-ManualInvoice.component.html',
  styleUrls: ['./edit-wmsm-ManualInvoice.component.css']
})
export class EditWmsmManualInvoice extends BaseComponent implements OnInit {
  fileList: NzUploadFile[] = [];
  loading: boolean = false;

  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  validateForm: FormGroup;
  validateForm2: FormGroup;
  showFiles: boolean;
  i = 0;
  editId: Number | null = 0;
  dateFormat = 'yyyy/MM/dd';
  FirstInvoiceDate;
  RNO: any;
  Pono: string;
  Currency: any;
  Company: any;
  disabledPONO: boolean = false;
  InvoiceSerialNumberIsNull: boolean = true;
  InvoiceInfo: any[] = [];
  ReceiptInfo: any[] = [];
  SubmitInvoiceInfo: any[] = [];
  SubmitReceiptInfo: any[] = []
  GetMaintainData: any;
  invoiceNo: any;
  Filename: any;
  otd1_Visible: boolean;
  otd2_Visible: boolean;
  Vendor_Punctual_Visible: boolean;
  Delay_Visible: boolean
  inputvalue: string;
  IsInputValue: boolean = false;
  tw: boolean;
  cn: boolean;
  en: boolean;
  InvoiceDatevalue: boolean = false;
  NontaxInvoiceAmountvalue: boolean = false;
  Taxesvalue: boolean = false;
  today = new Date();
  nzShowButton: boolean = true;
  Uploadfilelink: any;
  InvoiceNodata: any;
  uploadfilename: any;
  Submitdata: any[] = [];
  Role: string = '';
  ChangeValue: any;
  formattingdate: any;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  InvoiceInfoSerialNumberList: any[] = [];
  SerialNumberInInvoice: boolean = true;
  count = 0;
  InvoiceCodeIsNull: boolean = true;
  InvoiceNoIsNull: boolean = true;
  rowID: any;
  booleaninvoiceno: boolean;
  uploadValue: boolean;
  disabledfile: boolean;
  tabIndex: number = 0;
  @Input() set index(value) {
    if (!!value || value === 0) {
      this.tabIndex = value;
    }
  };

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private messageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    private DatePipe: DatePipe,

    private http: HttpClient,) { super() }


  ngOnInit() {
    this.validateForm = this.fb.group({
      aliases: this.fb.array([])
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.index = params['index']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.Pono = params['pono']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.Currency = params['currency']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.Company = params['company']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.invoiceNo = params['invoice']
    })

    this.getmaintainData()

  }



  get aliases() {
    return this.validateForm.get('aliases') as FormArray;
  }

  //添加新的一条对账
  addRow(): void {
    this.aliases.push(
      this.fb.group(
        {
          Pono: [this.Pono, [Validators.required]],
          InvoiceNo: ['', [Validators.required]],
          InvoiceDate: [],
          Currency: [this.Currency, [Validators.required]],
          NontaxInvoiceAmount: [0, [Validators.required]],
          Taxes: [0, [Validators.required]],
          Remark: ['', [Validators.required]],
          invoicefilePath: ['', [Validators.required]],
        }
      )
    )

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryInvoice.url}`;
    this.aliases.value.forEach(x => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
    })

    const params = {
      data:
      {
        list: this.aliases.value,
        Pono: this.Pono,
        Company: this.Company,
        InvoiceType: "NotEInvoice"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        var value: number;
        value = res.status;
        if (value == 200) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.success('暫存成功');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.success('暂存成功');
          }
          if (language == 'en') {
            this.NzMessageService.success('Temporary storage success');
          }
          this.loading = false;
          this.getmaintainData();
          return;
        }
        this.GetLanguage();
        this.loading = false
      },
      (error) => {
        this.loading = false;
      })



  }


  //删除一条对账
  deleteRow(index: any, value): void {
    this.loading = true;

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteMaintainInfo.url}`;
    const params = {
      data:
      {
        id: value.id,
        Pono: value.Pono,
        invoiceNo: value.InvoiceNo
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        this.NzMessageService.success(res.msg);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
    this.removeFormArrayItem(index);
  }

  cancel(): void {
  }

  //删除表单组
  removeFormArrayItem(index: any) {
    this.aliases.removeAt(index);
    this.loading = false;
  }




  repeat(array) {
    for (var i = 0; i < array.length; i++) {
      for (var j = i + 1; j < array.length; j++) {
        if (array[i] === array[j]) {
          array.splice(j, 1);
          j--;
        }
      }
    }
    return array;
  }

  //暫存对账
  SavegetmaintainData() {

    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryInvoice.url}`;
    this.aliases.value.forEach(x => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
    })

    const params = {
      data:
      {
        list: this.aliases.value,
        Pono: this.Pono,
        Company: this.Company,
        InvoiceType: "NotEInvoice"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        var value: number;
        value = res.status;
        if (value == 200) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.success('暫存成功');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.success('暂存成功');
          }
          if (language == 'en') {
            this.NzMessageService.success('Temporary storage success');
          }
          this.loading = false;

          return;
        }
        this.GetLanguage();
        this.loading = false
      },
      (error) => {
        this.loading = false;
      }
    );
  }


  //加载该PO下的所有发票
  getmaintainData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetWHQMaintainInvoiceListByPO.url}?Pono=` + this.Pono + '&role=' + this.Role;
    this.WebApiService.doGet(url).subscribe((res) => {
      this.GetMaintainData = res;
      this.aliases.clear();
      res.forEach(o => {
        this.aliases.push(
          this.fb.group(
            {
              id: [o.id],
              Pono: [this.Pono, [Validators.required]],
              InvoiceNo: [o.invoiceNo, [Validators.required]],
              InvoiceDate: [o.invoiceDate, [Validators.required]],
              Currency: [o.currency, [Validators.required]],
              NontaxInvoiceAmount: [o.nontaxInvoiceAmount, [Validators.required]],
              Taxes: [o.taxes, [Validators.required]],
              Remark: [o.remark, [Validators.required]],
              invoicefilePath: [o.invoicefilePath, [Validators.required]],
              invoicefileName: [o.invoicefileName],
              otherfilePath: [o.otherfilePath, [Validators.required]],
              otherInvoicefileName: [o.otherInvoicefileName],
              buyerOtherFiles: [o.buyerOtherFiles],
              buyerOtherFilesfileName: [o.buyerOtherFilesfileName],
              Status: [o.status]
            }
          )
        )
      }
      );
      this.loading = false;
    });
  }

  ////提交维护好的发票
  WHQSubmitList() {
    this.loading = true;
    this.Submitdata = []
    this.aliases.value.forEach(x => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
    })
    this.aliases.value.forEach(item => {
      if (item.Currency == "NTD") {
        this.booleaninvoiceno = (new RegExp(/^[a-zA-Z]{2}\d{8}$/).test(item.InvoiceNo))
        if (item.InvoiceDate != null && item.InvoiceNo != "" && item.NontaxInvoiceAmount != 0 && (item.invoicefilePath != null && item.invoicefilePath != "") && this.booleaninvoiceno == true) {
          var data = this.Submitdata.find(o => o.id == item.id)
          if (data == null || data == undefined) {
            this.Submitdata.push(item)
          }
        }
      }
      if (item.Currency != "NTD") {

        if (item.InvoiceDate != null && item.InvoiceNo != "" && item.NontaxInvoiceAmount != 0 && (item.invoicefilePath != null && item.invoicefilePath != "")) {
          var data = this.Submitdata.find(o => o.id == item.id)
          if (data === null || data === undefined) {

            this.Submitdata.push(item)
          }
        }
      }
    }
    );
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.WHQSubmit.url}`;
    const params = {
      data:
      {
        list: this.Submitdata,
        Pono: this.Pono,
        Company: this.Company,
        role: sessionStorage.getItem('role'),
        InvoiceType: "NotEInvoice"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        if (res.status == 200) {
          this.messageService.success(res.msg);
          this.getmaintainData();

          this.loading = false;
          return;
        }
        if (res.status !== 200) {
          this.messageService.warning(res.msg);
          this.getmaintainData();
          this.loading = false;
          return;
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );


  }


  //返回维护界面
  Retrun() {
    this.router.navigate(["/pages/wmsm-pages/SupplierManagement/StatementPaymentManagementWHQ/wmsmStatementMaintainWHQ"]);
  }

  //下载模板
  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadInvoiceInformationTemplate.url}`;
    const param = {};
    this.WebApiService.doPost(url, param, true).subscribe((res) => {
      this.downloadFile8(res, `wmsm_WHQList${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };


  beforeUploadFile = (file: NzUploadFile) => {
    if (file.size > 1024 * 1024 * 10) {
      this.NzMessageService.warning('上传文件不能超过10MB!');
      return false;
    }
    debugger
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryInvoice.url}`;
    this.aliases.value.forEach(x => {
      if (x.InvoiceDate != null) {
        //  var iii =  this.CompareDate(x.InvoiceDate)
        //  this.formattingdate= this.aliases.value.filter(o =>o).map((item) => {
        //   item.InvoiceDate =iii;
        //   return item
        // });
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
    })
    const params = {
      data:
      {
        list: this.aliases.value,
        Pono: this.Pono,
        Company: this.Company,
        InvoiceType: "NotEInvoice"
      }
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        debugger
        if (res.status == 200) {
          this.Uploadfile(file);
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  };


  //Upload批量上传
  saveExcelData(file) {
    this.loading = true;
    var type
    const formData = new FormData();
    formData.append('file', file);
    formData.append('NotEInvoice', type);
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UploadExcel.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          if (res['body'].status == 200) {
            this.getmaintainData();
            this.aliases.clear();
            this.NzMessageService.success(res['body'].msg);
          }
          if (res['body'].status == 0o0) {
            this.getmaintainData();
            this.aliases.clear();
            this.NzMessageService.warning(res['body'].msg);
          }
          setTimeout(() => {
            this.aliases.value.forEach(item => {
              if (item.Currency == "NTD") {
                this.booleaninvoiceno = (new RegExp(/^[a-zA-Z]{2}\d{8}$/).test(item.InvoiceNo))
                if (this.booleaninvoiceno == false) {
                  this.NzMessageService.warning('该发票' + item.InvoiceNo + '格式不正确，请修改', {
                    nzDuration: 7000
                  });
                }
              }
            });
          }, 200);


          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error('upload failed.');
          this.loading = false;
        }
      );
  }


  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) > 0;

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    // this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    // this.getResultData();
  }



  //上传文件
  Uploadfile(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', 'invoicefile');
    formData.append('id', this.rowID);
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.UploadFile.url}?PoNo=` + this.Pono + '&Invoice=' + this.InvoiceNodata;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http.request(req).pipe(filter((e) => e instanceof HttpResponse)).subscribe(
      (res) => {
        setTimeout(() => {
          this.Uploadfilelink = res['body'].data
          this.NzMessageService.success('文件上传成功');
          this.getmaintainData();
        }, 200);

        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error('upload failed.');
        this.loading = false;
      }
    );

  }

  Submitdisabled() {
    let subitdisablebbutton = true;
    this.aliases.value.forEach(item => {

      if (item.Currency == "NTD") {
        this.booleaninvoiceno = (new RegExp(/^[a-zA-Z]{2}\d{8}$/).test(item.InvoiceNo))
        if (item.InvoiceDate != null && this.booleaninvoiceno == true && item.NontaxInvoiceAmount != 0 && (item.invoicefilePath != null && item.invoicefilePath != "")) {
          subitdisablebbutton = false;
          return subitdisablebbutton;
        }
      }
      if (item.Currency != "NTD") {
        if (item.InvoiceDate != null && item.InvoiceNo != "" && item.NontaxInvoiceAmount != 0 && (item.invoicefilePath != null && item.invoicefilePath != "")) {
          subitdisablebbutton = false;
          return subitdisablebbutton;
        }
      }
    }
    );
    return subitdisablebbutton;
  }


  SelectFiledisabled() {
    let Filedisabled = true;
    this.aliases.value.forEach(item => {
      if (item.InvoiceDate != null && item.InvoiceNo != "" && item.NontaxInvoiceAmount != 0 && item.Taxes != "") {
        Filedisabled = false
        return Filedisabled;
      }
    }
    );
    return Filedisabled;
  }
  InvoiceNoMsgShow(note: string): void {
    if (note == 'InvoiceNo') {


      this.InvoiceNoChange
    }
  }

  InvoiceNoChange(value) {
    this.ChangeValue = value

  }

  CloseInput(note: string): void {
    if (this.ChangeValue.Currency == "NTD") {
      this.booleaninvoiceno = (new RegExp(/^[a-zA-Z]{2}\d{8}$/).test(this.ChangeValue.InvoiceNo));
      if (this.booleaninvoiceno == false) {
        this.NzMessageService.warning('该发票' + this.ChangeValue.InvoiceNo + '格式不正确，请修改', {
          nzDuration: 2000
        });
      }
    }
  }

  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }

  }

  //上传发票文件
  GetFileTokenOnClick(data) {
    this.WebApiService.downloadFileByToken(data.value.invoicefilePath).subscribe(
      (res) => {
        this.downloadFile8(res, data.value.invoicefileName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }
  //下载副档文件
  GetOtherFileTokenOnClick(data) {
    this.WebApiService.downloadFileByToken(data.value.otherfilePath).subscribe(
      (res) => {
        this.downloadFile8(res, data.value.otherInvoicefileName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }



  //删除发票
  DeleteUploadFile(data) {

    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteUploadFile.url}`;
    const params = {
      data:
      {
        FileToken: data.value.invoicefilePath,
        type: "File"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        this.NzMessageService.success(res.msg);
        this.getmaintainData();
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );

  }
  //删除副档
  DeleteUploadOtherFile(data) {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteUploadFile.url}`;
    const params = {
      data:
      {
        FileToken: data.value.otherfilePath,
        type: "otherFile"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        this.NzMessageService.success(res.msg);
        this.getmaintainData();
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );

  }


  GetRowInfo(value) {

    this.InvoiceNodata = value.InvoiceNo
    this.rowID = value.id;
  }


  //上传副档
  UploadOtherFile(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', this.rowID);
    formData.append('purpose', 'invoiceOtherFile');
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.UploadOtherFile.url}?PoNo=` + this.Pono + '&Invoice=' + this.InvoiceNodata;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http.request(req).pipe(filter((e) => e instanceof HttpResponse)).subscribe(
      (res) => {
        this.Uploadfilelink = res['body'].data
        this.NzMessageService.success('上传成功');
        setTimeout(() => {
          this.getmaintainData();
        }, 200);

        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error('upload failed.');
        this.loading = false;
      }
    );

  }
  //上传附檔文件
  beforeUploadOtherFile = (file: NzUploadFile) => {
    if (file.size > 1024 * 1024 * 10) {
      this.NzMessageService.warning('上传文件不能超过10MB!');
      return false;
    }
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryInvoice.url}`;

    this.aliases.value.forEach(x => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
    })
    const params = {
      data:
      {
        list: this.aliases.value,
        Pono: this.Pono,
        Company: this.Company,
        InvoiceType: "NotEInvoice"
      }
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status == 200) {
          this.UploadOtherFile(file);
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }



  //上传采购副档
  UploadBuyerOtherFiles(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', 'BuyerOtherFiles');
    formData.append('id', this.rowID);
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.UploadBuyerOtherFiles.url}?PoNo=` + this.Pono + '&Invoice=' + this.InvoiceNodata;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http.request(req).pipe(filter((e) => e instanceof HttpResponse)).subscribe(
      (res) => {
        this.Uploadfilelink = res['body'].data
        this.NzMessageService.success('上传成功');
        setTimeout(() => {
          this.getmaintainData();
        }, 200);

        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error('upload failed.');
        this.loading = false;
      }
    );

  }
  //上传采购附檔文件
  beforeBuyerOtherFiles = (file: NzUploadFile) => {
    if (file.size > 1024 * 1024 * 10) {
      this.NzMessageService.warning('上传文件不能超过10MB!');
      return false;
    }
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryInvoice.url}`;
    const params = {
      data:
      {
        list: this.aliases.value,
        Pono: this.Pono,
        Company: this.Company,
        InvoiceType: "NotEInvoice"
      }
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status == 200) {
          this.UploadBuyerOtherFiles(file);
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  //删除采购副档
  DeleteBuyerOtherFiles(data) {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteUploadFile.url}`;
    const params = {
      data:
      {
        FileToken: data.value.buyerOtherFiles,
        type: "BuyerFiles"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        this.NzMessageService.success(res.msg);
        this.getmaintainData();
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );

  }

  GetBuyerOtherFile(data) {
    this.WebApiService.downloadFileByToken(data.value.buyerOtherFiles).subscribe(
      (res) => {
        this.downloadFile8(res, data.value.buyerOtherFilesfileName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  CompareDate(date: any): any {
    return this.DatePipe.transform(date, 'yyyy-MM-dd');
  }

}
